import { render } from "./AddGroup.vue?vue&type=template&id=7f681c72&scoped=true&ts=true"
import script from "./AddGroup.vue?vue&type=script&lang=ts"
export * from "./AddGroup.vue?vue&type=script&lang=ts"

import "./styles/Groups.scss?vue&type=style&index=0&id=7f681c72&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f681c72"]])

export default __exports__